<template>
    <div class="navbarbox">
        <van-nav-bar
          :title="title" 
          left-arrow
          @click-left="onClickLeft"
         
        />
      
    </div>
</template>

<script>
export default {
 props:['titlename'], 
 data() {
        return {
            title:this.titlename
        }
  },
  created(){
    //this.title=this.titlename;
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    }
    
  }
};
</script>

<style scoped>
.navbarbox{  overflow: hidden;}
.van-nav-bar{ height: 50px; line-height: 50px;top:0; position: fixed;border-bottom: 1px solid #eee;  width: 100%;overflow: hidden;}
.van-nav-bar__title{font-weight: bold; font-size:0.8rem;}
.van-icon-arrow-left:before{
  color: #333; font-size:1rem;

}
</style>


// WEBPACK FOOTER //
// src/components/public/navbar.vue